import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";

import Sortable from "../../../../componets/Sortable";
import { reorderBanners } from "../../../../actions/mine_craft/bannersActions";

const Reorder = () => {
  const dispatch = useAppDispatch();
  const reorderIds = useAppSelector(state => state.mineCraft.banners.reorderIds);
  const banners = useAppSelector(state => state.mineCraft.banners.entities);

  function onClickSave(ids: any[]) {
    dispatch(reorderBanners({ ids }));
  }

  return (
    <div className='v-banners-reorder'>
      <h6 className="v-content-label o-sm">Reorder</h6>

      {
        reorderIds &&
          <Sortable
            ids={reorderIds}
            onClickSave={onClickSave}
            imageKey={'image_url'}
            items={banners}
            titleKey='name'
          />
      }
    </div>
  )
}

export default Reorder;
